import { render, staticRenderFns } from "./statisticBlock.vue?vue&type=template&id=33724cda&scoped=true&"
import script from "./statisticBlock.vue?vue&type=script&lang=js&"
export * from "./statisticBlock.vue?vue&type=script&lang=js&"
import style0 from "./statisticBlock.vue?vue&type=style&index=0&id=33724cda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33724cda",
  null
  
)

export default component.exports